const DEFAULT_DISPLAY_LABELS = {
  LABEL: "Label",
  START_DATE: "Start",
  END_DATE: "End",
  ANNIVERSARY: "Anniversary"
};

export { DEFAULT_DISPLAY_LABELS };
